import styled, { css } from "styled-components"


const Container = styled.div`
  display: flex;
  margin-right: 10px;
  transform: rotate(${props => props.rotation || 0});
  ${props =>
    props.center
      ? css`
          display: flex;
          align-items: center;
        `
      : ""};
  ${props =>
    props.small
      ? css`
          width: 11px;
          height: 5px;
          stroke-width: 2px;
        `
      : ""};
`

export default Container



// WEBPACK FOOTER //
// ./assets/common/components/icons/IconContainer.js